import apiAxios from '@/apiAxios.js'

export default {
  components: {},
  data() {
    return {
      editItem: {},

      queryIsLoading: false,
      queryResult: [],

      selectArr:[]
    }
  },
  watch: {},
  computed: {},
  methods: {
    selectChange(selection) {
      this.selectArr = []
      selection.forEach(vv => {
        this.selectArr.push(vv.id)
      });
    },

    async saveEdit() {
      const { data } = await apiAxios.post(`/em/BudgetRollingCompany`, this.selectArr)
      this.$message.success(data.message)
      await this.loadData()
    },

    async loadData() {
      this.queryIsLoading = true
      this.queryResult = []
      const  data1  = await apiAxios.get(`/base/company/noPage`)
      const  data2  = await apiAxios.get(`/em/BudgetRollingCompany`)
      this.queryIsLoading = false
      this.queryResult = data1.data.result
      this.selectArr = data2.data.result
      this.$nextTick(() => {
        this.$refs.refTable.clearSelection()
        this.selectArr.forEach((vv, ii) => {
          this.queryResult.forEach((vv1, ii1) => {
            if (vv.companyId === vv1.id) {
              this.$refs.refTable.toggleRowSelection(vv1)
            }
          })
        })
      })
    },
  },
  async mounted() {
    await this.loadData()
  },
}
